// extracted by mini-css-extract-plugin
module.exports = {"skeletonWrap":"skeletonWrap--uTL7D","skeletonTitle":"skeletonTitle--u83bI"};